<!-- <p-breadcrumb [model]="breadcrumb"></p-breadcrumb> -->
<h1>Payee Termination</h1>
<main>
  <section>
    <div class="instruction-text">Terminate an employee or payee.</div>
      <div>
        <div class="p-grid">

          <div class="p-col-12 p-lg-4">
            <div class="p-grid">
            <div class="p-col-12 p-lg-3"><label for="name">Name</label></div>
          <div class="p-col-12 p-lg-9">[name]</div>
            </div>
        </div>

        <div class="p-col-12 p-lg-4">
          <div class="p-grid">
          <div class="p-col-12 p-lg-3"><label for="type ">Type</label></div>
            <div class="p-col-12 p-lg-9">[employee type]</div>
          </div>
         </div>
         <div class="p-col-12 p-lg-4">
           <div class="p-grid">
             <div class="p-col-12 p-lg-3"><label for="payrollperiod">Status</label></div>
          <div class="p-col-12 p-lg-9">[employee status]</div>
          </div>
         </div>
        </div>
      </div>

      <div>
        <div>
          <div class="p-grid" style="margin-top:15px;">
           <div class="p-col-12 p-lg-2"><label for="terminationDate">Termination Date </label></div>
           <div class="p-col-12 p-lg-10"><p-calendar [showIcon]="true" name="terminationDate"></p-calendar></div>
            <!--[(ngModel)]="personalInfo.birthDate"-->
          </div>
          <div class="p-grid">
              <div class="p-col-12 p-lg-2"> <label for="lastDate">Last Date at Work </label></div>
              <div class="p-col-12 p-lg-10"> <p-calendar [showIcon]="true" name="lastDate"></p-calendar></div>
            <!--[(ngModel)]="personalInfo.birthDate"-->
          </div>
          <div class="p-grid">
              <div class="p-col-12 p-lg-2"> <label for="reason">Termination Reason </label></div>
              <div class="p-col-12 p-lg-10"> <p-dropdown name="type" [style]="{'overflow':'visible', 'width':'100%'}" placeholder="Select..." [showClear]="true"></p-dropdown></div>
            <!--[options]="typeMenu" (onChange)="onChangeType(type)"  -->
          </div>
          <div class="p-grid">
              <div class="p-col-12 p-lg-2">  <label for="reason">Notes </label></div>
              <div class="p-col-12 p-lg-10"> <textarea [rows]="5" [cols]="30" pInputTextarea autoResize="autoResize"></textarea></div>
          </div>
        </div>
      </div>
    <div style="text-align: right;">
      <button pButton type="button" icon="fa fa-close" (click)="closeDialog()" label="Close" class="button-inaction"></button>
      <button pButton type="button" icon="fa fa-check" (click)="saveTerminationDetails()" label="Save" class="button-action"></button>
    </div>
  </section>
    </main>
